import React, { useState } from "react";
import './LoginLogoutButton.css'
import { useAuth0 } from "@auth0/auth0-react";
import AccountSettings from './AccountSettings'
import ConnectWallet from './ConnectWallet'
import SettingsIcon from './images/icon-settings.png'
import WalletIcon from './images/icon-wallet.png'
import LogoutIcon from './images/icon-log-out.png'
import LoginButton from './login';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-modal';
import { useNavigate } from "react-router-dom";

const LoginLogoutButton = ({ wallets, setWallets }) => {
    const [showAccountSettingsModal, setShowAccountSettingsModal] = useState(false);
    const [showAddWalletModal, setShowAddWalletModal] = useState(false);
    const { isAuthenticated, user, logout } = useAuth0();
    const navigate = useNavigate();

    return (
        <div className="login-buttons">
            <LoginButton />
            <Dropdown style={{ display: isAuthenticated ? 'block' : 'none'}}>
                <Dropdown.Toggle id="dropdown-basic">
                    { isAuthenticated && user["https://futurefest.io/username"] }
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    { isAuthenticated && user['https://futurefest.io/roles']?.includes("Admin") && <Dropdown.Item onClick={() => navigate('/admin') }><img src={SettingsIcon} alt="Settings icon" /> Admin Console</Dropdown.Item> }
                    <Dropdown.Item onClick={() => setShowAccountSettingsModal(true)}><img src={SettingsIcon} alt="Settings icon" /> Account Settings</Dropdown.Item>
                    <Dropdown.Item onClick={() => setShowAddWalletModal(true)}><img src={WalletIcon} alt="Wallet icon" /> Connect Wallet</Dropdown.Item>
                    <Dropdown.Item onClick={() => logout({ returnTo: window.location.origin })}><img src={LogoutIcon} alt="Logout icon" />&nbsp;&nbsp;Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <Modal
                isOpen={showAccountSettingsModal}
                parentSelector={()=> document.querySelector('.App')}
                className="AccountSettingsModal__Content ff-modal-content"
                overlayClassName="AccountSettingsModal__Overlay ff-overlay"
                onRequestClose={() => setShowAccountSettingsModal(false)}
                shouldCloseOnOverlayClick={true}>
                <AccountSettings wallets={wallets} setWallets={setWallets} />
            </Modal>
            <Modal
                isOpen={showAddWalletModal}
                parentSelector={()=> document.querySelector('.App')}
                className="AddWalletModal__Content ff-modal-content"
                overlayClassName="AddWalletModal__Overlay ff-overlay"
                onRequestClose={() => setShowAddWalletModal(false)}
                shouldCloseOnOverlayClick={true}>
                <ConnectWallet wallets={wallets} setWallets={setWallets} callback={() => setShowAddWalletModal(false)} />
            </Modal>
        </div>
    );
};

export default LoginLogoutButton;
